import { orderedListOfBreakpoints } from '../../components/BreakpointProvider/config.js';
import { useCurrentBreakpoint } from '../../components/BreakpointProvider/useCurrentBreakpoint.js';
/**
 * @example usebreakpointDown('md') // returns true if current breakpoint matches md and below
 */
export const useBreakpointDown = upToAndIncluding => {
  const currentBreakpoint = useCurrentBreakpoint();
  return orderedListOfBreakpoints.indexOf(currentBreakpoint) <= orderedListOfBreakpoints.indexOf(upToAndIncluding);
};